<template>
  <div id="mbti-result" class="section">
    <div class="jumbotron text-right">
      <div class="container">
        <h2>Tipe kepribadianmu adalah</h2>
        <h1>INTJ</h1>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-7">
          <p>
            Seseorang yang berkepribadian INTJ sering disebut pengatur atau The Masterminds. Hanya ada 2-4% populasi INTJ di dunia. Dimana menurut dimensinya INTJ berarti Introversion atau seseorang yang tidak suka akan hubungan dan dunia luar. Intuition dimana mereka membicarakan hal yang bersifat masa depand an belum jelas atau abstrak. Thinking merupakan dimensi dasar mereka dimana mereka suka menilai dan berpikir sebelum bertindak dan sangat objektif. Judging merupakan mereka yang merencanakan berbagai hal sebelum bertindak
          </p>
          <p>
            Ciri kepribadian INTJ adalah:
            <ul>
              <li> Ahli dalam mengatur strategi atau melihat gambaran secara global.</li>
              <li> Menyukai tantangan teoritis yang sulit.</li>
              <li> Menghargai nilai pengetahuan dan efisiensi.</li>
              <li> Mampu menyerap teori yang kompleks dan terdorong untuk menciptakan keteraturan dan struktur dari abstraksi teoritis.</li>
            </ul>
          </p>
          <p>Saran dan pekerjaan yang cocok:
            <ul>
              <li>
                Cobalah untuk mengungkapkan berbagai hal dengan benar dan hargai banyak orang, jangan mengikuti perdebatan yang tidak penting.
              </li>
              <li>
                Belajar untuk berempati dan peka terhadap orang lain.
              </li>
              <li>
                Pekerjaan yang cocok adalah analisis, dokter, pimpinan perusahaan, ahli keilmuan, insinyur dan hakim.
              </li>
            </ul>
          </p>
          <p>
            Asmara yang cocok bersama INTJ adalah mereka yang ENFP dan ENTP, namun pemilihan pasangan ini bukan alasan anda untuk membatasi pencarian pasangan anda.
          </p>
        </div>
        <div class="col-lg-5">
          <img src="../../../assets/images/mbti/INTJ.png" alt="" class="illustration">
          <div class="media">
            <img src="../../../assets/images/mbti/Introversion.png" class="mr-3" alt="">
            <div class="media-body">
              <h5 class="introversion">Introversion</h5>
              <p>cenderung pendiam dan suka menyendiri</p>
            </div>
          </div>
          <div class="media">
            <img src="../../../assets/images/mbti/Intution.png" class="mr-3" alt="">
            <div class="media-body">
              <h5 class="intution">Intution</h5>
              <p>lebih fokus terhadap gambaran masa depan</p>
            </div>
          </div>
          <div class="media">
            <img src="../../../assets/images/mbti/Thinking.png" class="mr-3" alt="">
            <div class="media-body">
              <h5 class="thinking">Thinking</h5>
              <p>membuat keputusan berdasarkan logika</p>
            </div>
          </div>
          <div class="media">
            <img src="../../../assets/images/mbti/Judgement.png" class="mr-3" alt="">
            <div class="media-body">
              <h5 class="judgement">Judgement</h5>
              <p>cenderung membiarkan pilihan tetap terbuka</p>
            </div>
          </div>
        </div>
      </div>
      <ShareButton :result="result" />
    </div>
  </div>
</template>

<script>
export default {
  name: "INTJ",
  components: {
    ShareButton: () => import('@/components/ShareButton'),
  },
  data() {
    return {
      result: {
        name: 'INTJ',
        slug: 'intj'
      }
    }
  }
};
</script>

<style scoped>

</style>
